export default __webpack_public_path__ + "static/media/deployment.71a54217.png";